import { createRouter, createWebHashHistory } from "vue-router";
import Login from "../views/LoginPage";
import test from "../views/TestPage";
import TaskPage from "../views/TaskPage";
import Product from "../views/ProductPage";
import CartPage from "../views/CartPage";
import ReportSales from "../views/Report/ReportSales";
import CustomerPage from "../views/CustomerPage";
//import RepeatFactor from "../views/RepeatFactor.vue";
import AddressPage from "../views/AddressPage";
import ReportCustomer from "../views/Report/ReportCustomer";
import Report from "../views/Report/Report";
import FactorReport from "../views/Report/FactorReport";
import AddCustomerPage from "../views/AddCustomerPage"
import store from "@/store";
const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    redirect: "/customer",
  },
  {
    path: "/task",
    name: "TaskPage",
    component: TaskPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/customer",
    name: "CustomerPage",
    component: CustomerPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/addcustomer",
    name: "AddCustomerPage",
    component: AddCustomerPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/reportcustomer",
    name: "ReportCustomer",
    component: ReportCustomer,
    meta: { requiresAuth: true },
  },
  {
    path: "/report",
    name: "Report",
    component: Report,
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:customerId",
    name: "گزارش",
    component: ReportSales,
    meta: { requiresAuth: true },
  },
  {
    path: "/address/:customerId",
    name: "آدرس",
    component: AddressPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:customerId/anbar/:anbarId",
    name: "محصولات",
    component: Product,
    meta: { requiresAuth: true },
  },
  {
    path: "/cart",
    name: "CartPage",
    component: CartPage,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/repeatfactor/:factorId",
    name: "FactorReport",
    component: FactorReport,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/test",
    name: "test",
    component: test,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(!store.getters.isLoggedIn);
  // اگر صفحه مقصد، صفحه لاگین نباشه و کاربر لاگین نباشه هدایت به لاگین
  if (to.path !== "/login" && !store.getters.isLoggedIn) {
    console.log("کاربر لاگین نیست، هدایت به لاگین");
    next("/login?relogin=true");
  } else {
    next();
  }
});

export default router;
